import Signin from "./pages/Signin/Signin";
import GoogleRedirect from "./pages/Signin/GoogleRedirect";
import Navbar from "./components/Navbar/Navbar.jsx";
import GithubRedirect from "./pages/Signin/GithubRedirect";
import ResetPassword from "./pages/Signin/ResetPassword";
import Framework from "./pages/Frameworks/Frameworks.jsx";

import NotFound from "./components/ErrorPage/NotFound.jsx";
import Dashboard from "./pages/Dashboard/Dashboard";
import Profile from "./pages/Profile/Profile.jsx";
import Settings from "./pages/Settings/Settings.jsx";
import Connectors from "./pages/Connectors/Connectors.jsx";
import AudytLLM from "./pages/AudytLLM/AudytLLM.jsx";
import Analytics from "./pages/Analytics/Analytics.jsx";
import Evidences from "./pages/Evidences/Evidences.jsx";
import Library from "./pages/Library/Library.jsx";
import Metrics from "./pages/Metrics/Metrics.jsx";
import UserManagement from "./pages/UserManagement/UserManagement.jsx";
import Report from "./pages/Report/Report.jsx";
import FormBuilder from "./pages/FormBuilder/FormBuilder.jsx";
import PasswordlessSignIn from "./pages/Signin/PasswordlessSignIn.jsx";
import VerifyLogin from "./pages/Signin/VerifyLogin.jsx";
import Form from "./pages/Connectors/Form.jsx";


import SingleTypemetrics from "./pages/Metrics/SingleTypemetrics.jsx";
import CreateMetricForm from "./pages/Metrics/CreateMetricForm.jsx";
import EditMetricForm from "./pages/Metrics/EditMetricForm.jsx";
import Survey from "./pages/External/Survey.jsx";
import Done from "./pages/External/Done.jsx";
import MetricsBuilder from "./pages/Playground/MetricsBuilder.jsx";
import MetricsBuilderCards from "./pages/Playground/MetricsBuilderCards.jsx";
import EditFormBuilder from "./pages/FormBuilder/EditFormBuilder.jsx";
import Policies from "./pages/Policies/Policies.jsx";
import CreateLibrary from "./pages/Library/CreateLibrary.jsx";
import EditLibrary from "./pages/Library/EditLibrary.jsx";
import PoliciesBuilder from "./pages/PoliciesBuilder/PoliciesBuilder.jsx";
import PoliciesCreateBuilder from "./pages/PoliciesBuilder/PoliciesCreateBuilder.jsx";

import SearchPage from "./pages/Search/SearchPage.jsx";
import RequestPage from "./components/ErrorPage/RequestPage.jsx";
import InviteRequest from "./pages/InviteRequest/InviteRequest.jsx";
import NotAccess from "./components/ErrorPage/NotAccess.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import PrintPolicyReport from "./pages/Policies/PrintPolicyReport.jsx";
import SinglePolicy from "./pages/Policies/SinglePolicy.jsx";
import Procedures from "./pages/Policies/Procedures.jsx";



import CreateFramework from "./pages/Frameworks/CreateFramework.jsx";

import MetricCategroy from "./pages/Metrics/MetricCategroy.jsx";
import Logs from "./pages/Logs/Logs.jsx";
import OnboardingOrganization from "./pages/OnboardingOrg/OnboardingOrganization.jsx";
import DataImport from "./pages/DataImport/DataImport.jsx";
import OrgList from "./pages/OrgList/OrgList.jsx";
import SurveyPlayground from "./pages/SuveryPlayground/SurveyPlayground.jsx";
import { EditSurveyBuilder } from "./pages/survey-builder/EditSurveyBuilder.jsx";
import { SurveyBuilder } from "./pages/survey-builder/SurveyBuilder.jsx";
import DefaultFrameworkView from "./components/DefaultFrameworkView.jsx";
import SetNewPassword from "./pages/Signin/SetNewPassword.jsx";
import ViewFrameworkMetric from "./pages/Frameworks/ViewFrameworkMetric.jsx";
import Signup from "./pages/Signin/Signup.jsx";
import OTP from "./pages/Signin/OTP.jsx";
import { Navigate } from "react-router-dom";
import MainPage from "./pages/MainPage/MainPage.jsx";
import CreateReportWizard from "./pages/Report/CreateReportWizard.jsx";
import Haya from "./pages/Haya/Haya.jsx";
import Thread from "./pages/Threads/Thread.jsx";
import EditPoliciesBuilder from "./pages/PoliciesBuilder/EditPoliciesBuilder.jsx";
import EditReport from "./pages/Report/EditReport/EditReport.jsx";
import CleanupForms from "./pages/FormBuilder/CleanupForms.jsx";
import TaskCountPage from "./pages/TaskCountPage.jsx";
import TaskControlTrackerMain from "./pages/TaskControlTracker/TaskControlTrackerMain.jsx";
import MetricTaskDetails from "./pages/TaskControlTracker/MetricTaskDetails.jsx";
import CreateTaskModal from "./pages/TaskControlTracker/CreateTaskModal.jsx";


// Placeholder Pages
import NotificationsTasks from "./pages/NotificationsTasks/NotificationsTasks.jsx";
import DataCollectionHub from "./pages/PlaceholderPages/DataCollectionHub.jsx";
import ESGDocuments from "./pages/PlaceholderPages/ESGDocuments.jsx";
import AnalyticsDashboards from "./pages/PlaceholderPages/AnalyticsDashboards.jsx";
import StandardsMapping from "./pages/PlaceholderPages/StandardsMapping.jsx";
import BuiltinStandardsMapping from "./pages/PlaceholderPages/BuiltinStandardsMapping.jsx";


import AuditLogs from "./pages/PlaceholderPages/AuditLogs.jsx";
import WorkflowConfig from "./pages/PlaceholderPages/WorkflowConfig.jsx";

import AuditReports from "./pages/Evidences/AuditReports.jsx";
import PerformanceData from "./pages/Evidences/PerformanceData.jsx";
import StakeholderFeedback from "./pages/Evidences/StakeholderFeedback.jsx";
import PlaceholderPage from "./pages/PlaceholderPages/PlaceholderPage.jsx";

import WorkflowManagement from "./pages/Workflows/WorkflowManagement.jsx";
import ApprovalDashboard from "./pages/ApprovalDashboard/ApprovalDashboard.jsx";
import WorkflowTest from "./components/WorkflowTest.jsx";



const ComponentList = {
  Signin: Signin,
  GoogleRedirect,
  Navbar,
  GithubRedirect,
  ResetPassword,
  Framework,

  NotFound,
  Dashboard,
  Profile,
  Settings,
  Connectors,
  AudytLLM,
  Analytics,
  Evidences,
  Library,
  Metrics,
  UserManagement,
  Report,
  FormBuilder,
  PasswordlessSignIn,
  VerifyLogin,
  Form,


  SingleTypemetrics,
  CreateMetricForm,
  EditMetricForm,
  Survey,
  Done,
  MetricsBuilder,
  MetricsBuilderCards,
  EditFormBuilder,
  Policies,
  CreateLibrary,
  EditLibrary,
  PoliciesBuilder,
  PoliciesCreateBuilder,

  SearchPage,
  RequestPage,
  InviteRequest,
  NotAccess,
  ProtectedRoute,
  SinglePolicy,
  Procedures,



  CreateFramework,

  MetricCategroy,
  Logs,
  OnboardingOrganization,
  DataImport,
  OrgList,
  SurveyPlayground,
  EditSurveyBuilder,
  SurveyBuilder,
  DefaultFrameworkView,
  SetNewPassword,
  ViewFrameworkMetric,
  Signup,
  OTP,
  Navigate,
  MainPage,
  PrintPolicyReport,
  CreateReportWizard,
  Haya,
  Thread,
  EditPoliciesBuilder,
  EditReport,
  CleanupForms,
  TaskCountPage,
  TaskControlTrackerMain,
  MetricTaskDetails,
  CreateTaskModal,

  
  // Placeholder Pages
  NotificationsTasks,
  DataCollectionHub,
  ESGDocuments,
  AnalyticsDashboards,
  StandardsMapping,
  BuiltinStandardsMapping,

  AuditLogs,
  WorkflowConfig,

  AuditReports,
  PerformanceData,
  StakeholderFeedback,
  PlaceholderPage,

  WorkflowManagement,
  ApprovalDashboard,
  WorkflowTest,



};

const getComponent = (name) => {
  return ComponentList[name] || NotFound;
};

export default getComponent;
